export default "__VITE_ASSET__oFZ6vruV__"